"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const milestones = [{
  quarter: "Phase 1",
  description: "Comprehensive site audits and risk identification to establish baseline safety benchmarks across all operational fronts."
}, {
  quarter: "Phase 2",
  description: "Deployment of cloud-based WHS management software and integration of real-time incident reporting protocols for all teams."
}, {
  quarter: "Phase 3",
  description: "Organisation-wide certification and ongoing compliance monitoring to ensure sustained zero-harm workplace standards."
}];
export default function ExpansionToSyria() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardRef,
    isVisible: isCardVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="227133" id="risk-management-whs-systems" className="bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1641543/img/syria_expansion_parallax_bg.png)] bg-cover bg-center bg-fixed opacity-10"></div>

      {}
      <div className="absolute inset-0 bg-background/90"></div>

      <div className="max-w-7xl mx-auto px-4 py-24 md:py-32 relative z-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center min-h-[80vh]">

        {}
        <div className="space-y-10 text-foreground">
          <div ref={textRef} className={`transition-all duration-700 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default mb-6 leading-tight tracking-tight">
              WHS Systems & <span className="text-primary">Workplace Safety</span>
            </h2>
            <p className="text-lg md:text-xl font-default leading-relaxed text-muted-foreground max-w-xl">
              We ensure full <span className="text-primary font-semibold">NSW WorkCover compliance</span> through rigorous safety frameworks tailored to the NSW industrial relations landscape. Our comprehensive WHS systems integrate workplace safety protocols with robust compliance frameworks, encompassing advanced safety management systems, proactive incident reporting, and specialized team training. By maintaining continuous compliance monitoring, we deliver a zero-harm environment that protects your workforce and ensures long-term business reliability.
            </p>
          </div>

          <div ref={cardRef} className={`transition-all duration-700 delay-200 ease-out transform ${isCardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <Card className="bg-card/50 backdrop-blur-md border-border text-card-foreground shadow-lg">
              <CardHeader className="pb-4">
                <CardTitle className="text-2xl font-default text-primary tracking-wide">Implementation Roadmap</CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                {milestones.map((milestone, i) => <div key={i} data-index={i} className="relative pl-6 border-l-2 border-primary/30 hover:border-primary transition-colors duration-300">
                    <div className="absolute w-3 h-3 bg-primary rounded-lg -left-[7px] top-1.5"></div>
                    <h4 className="font-bold text-lg font-default tracking-wide">{milestone.quarter}</h4>
                    <p className="text-muted-foreground font-default text-sm mt-1.5 leading-relaxed">{milestone.description}</p>
                  </div>)}
              </CardContent>
            </Card>
          </div>
        </div>

        {}
        <div ref={imageRef} className={`relative h-full min-h-[400px] flex items-center justify-center transition-all duration-1000 delay-300 ease-out transform ${isImageVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
          {}
          <div className="absolute inset-0 bg-primary/10 blur-[100px] rounded-lg"></div>

          <img src="https://bottomupprojects.com.au/wp-content/uploads/2026/04/istockphoto-2242120788-612x612-1.jpg" alt="Detailed map of New South Wales highlighting regional workplace safety coverage and compliance zones" className="w-full h-auto max-w-lg object-contain relative z-10 drop-shadow-2xl" loading="lazy" decoding="async" />
        </div>

      </div>
    </section>;
}